var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5469,
    cy: 20.01,
    r: 20,
    fill: "#FF9932"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2464 11.6102L28.8672 24.8102C28.9374 24.9318 28.9744 25.0698 28.9744 25.2102C28.9744 25.3507 28.9374 25.4886 28.8672 25.6102C28.797 25.7318 28.696 25.8328 28.5744 25.903C28.4528 25.9733 28.3148 26.0102 28.1744 26.0102H12.9328C12.7924 26.0102 12.6544 25.9733 12.5328 25.903C12.4112 25.8328 12.3102 25.7318 12.24 25.6102C12.1698 25.4886 12.1328 25.3507 12.1328 25.2102C12.1328 25.0698 12.1698 24.9318 12.24 24.8102L19.8608 11.6102C19.931 11.4886 20.032 11.3876 20.1536 11.3174C20.2752 11.2472 20.4132 11.2103 20.5536 11.2103C20.694 11.2103 20.832 11.2472 20.9536 11.3174C21.0752 11.3876 21.1762 11.4886 21.2464 11.6102ZM14.3184 24.4102H26.7888L20.5544 13.6102L14.3184 24.4102ZM19.7536 22.0102H21.3536V23.6102H19.7536V22.0102ZM19.7536 16.4102H21.3536V20.4102H19.7536V16.4102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInRed);
export default __webpack_public_path__ + "static/media/IN_Red.6213a2ce1c36cb78c780affee4d9cf77.svg";
export { ForwardRef as ReactComponent };